<template>
  <div
    class="infinite-scroll z-10 auto-scroll"
  >
    <slot />
    <slot />
    <slot />
  </div>
</template>

<script setup lang="ts">
</script>

<style>
@keyframes autoScroll {
  from {
    transform: translateX(0%);
  }
  to {
    transform: translateX(-33.33333%);
  }
}

.auto-scroll {
  animation: autoScroll 90s infinite linear;
}
</style>
